var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGift = function SvgGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M1 4h12v10H1zM6 3.5v11M8 3.5v11M1 8h5M8 8h5M1 10h5M8 10h5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14 3.596c.115-.864.697-1.959 1.76-2.598.674-.405 1.84-.671 2.38.301.541.976-.26 1.889-.94 2.297-.19.115-.643.33-.84.404M6.86 3.596C6.744 2.732 6.162 1.637 5.1.998 4.426.593 3.26.327 2.72 1.3c-.541.976.26 1.889.94 2.297.19.115.643.33.84.404",
    stroke: "#000"
  })));
};
export default SvgGift;